import * as Sentry from "@sentry/nuxt";

Sentry.init({
  // If set up, you can use your runtime config here
  // dsn: useRuntimeConfig().public.sentry.dsn,
  dsn: "https://3194a886617e52b13857ec6035eeb59d@o4509057019609088.ingest.us.sentry.io/4509057045168128",

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  
  // If you don't want to use Session Replay, just remove the line below:
  integrations: [Sentry.replayIntegration(
    {
      ignore: [".ignore-me", "wide"],
      maskAllText: false,
      blockAllMedia: false
    }
  )],
  
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // 🎯 Ignore Errors
  beforeSend(event, hint) {
    const errorMessage = event?.exception?.values?.[0]?.value || ''

    const ignoreList = [
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to fetch dynamically imported module',
      "Cannot read properties of null (reading 'insertBefore')",
      "Cannot read properties of null (reading 'parentNode')",
      'isValidChild',
      'TypeError: Right side of assignment cannot be destructured',
      'Load failed (storage.elfsight.com)',
      "Cannot read properties of null (reading 'transition')",
      "Cannot read properties of null (reading 'nodeType')",
      "Event `Event` (type=error) captured as promise rejection",
      'Cannot convert object to primitive value',
      "undefined is not an object (evaluating 'e.default')",
      "Failed to execute 'getComputedStyle' on 'Window': parameter 1 is not of type 'Element'.",
      "undefined is not an object (evaluating 't.getRng')",
      "Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing."
    ]

    if (ignoreList.some(msg => errorMessage.includes(msg))) {
      console.log('[Sentry] Ignored error:', errorMessage)
      return null
    }

    return event
  }
});